import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className="overlay">
    <div className="loader" />
  </div>
);

export { Loader };
